import { StyleSheet } from 'react-native'
import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes'

const styles = StyleSheet.create({
  container: (theme) => ({
    backgroundColor: theme.colors.backgroundColorSix,
    width: 240,
    height: 250,
    borderRadius: 6,
    margin: 6,
    elevation: 2,
    shadowColor: Colors.black,
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowRadius: 4,
    shadowOpacity: 0.16,
  }),
  touchable: {
    flex: 1,
  },
  image: {
    flex: 1,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    overflow: 'hidden',
    position: 'relative',
  },
  label: {
    backgroundColor: Colors.white,
    borderRadius: 10,
    maxWidth: '71%',
    height: 20,
    paddingHorizontal: 12,
    margin: 16,
    overflow: 'hidden',
    alignSelf: 'flex-start',
  },
  details: {
    height: 96,
    padding: 16,
    justifyContent: 'space-between',
  },
  action: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  starContainer: {
    position: 'absolute',
    top: 0,
    right: 0,
    padding: 16,
  },
  partnerContainer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    padding: 16,
  },
})

export default styles
